import { combineReducers } from "@reduxjs/toolkit";
import applicantsReducers from "./Applicants/applicantsSlice";

const staffReducer = combineReducers({
  applicants: applicantsReducers,
});

export default staffReducer;
